














































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import charts from '../../components/charts/index.vue'
import cardInfo from  '../../components/charts/inforCard.vue'
import mapStatistics from  '../../components/charts/mapStatistics.vue'
import myTable from '../../components/table/my-table.vue'
import Query from '../../components/query/index.vue'
//子查询
import subQuery from '../../components/subquery/index.vue'


@Component({
  components:{charts,cardInfo,mapStatistics,myTable,Query,subQuery}
}) 
export default class extends AbpBase{
    subQueryShow = false
    subQueryData:any = {}
    columns:any = []
    list = []
    params = {
        loading:false,
        pageSize:10000,
        page:1,
        queryParaIdArr:[],
        queryTypeId:null
    }
    search(data:any){
        this.params.page = 1;
        this.params.queryParaIdArr = data.map((item:any)=>{
            let value = item.dataType==7?item.defaultValue.join(','):item.dataType==10?item.defaultValue.join('$'):item.defaultValue
            return {
                key:item.id,
                value:value
            }
        })
        // this.columns.forEach((item:any,index)=>{
        //     item.loading = true
        //     this.getData(item.id,index)
        // })
    }
    searchDetail(data:any,index:any){
        this.params.page = 1;
        this.params.queryParaIdArr = data.map((item:any)=>{
            return {
                key:item.id,
                value:item.defaultValue
            }
        })
        this.columns[index].loading = true
        this.getData(this.columns[index].id,index,this.columns[index].chartType)

    }
    /**
	 * 数据钻取方法
	 * @param row Array or Object
	 * @param item 当前点击图表块描述
    **/
    getSub(row:any,item:any){
        if(!item.drillQueryTypeId){
            return false
        }

        if(item.chartType==12){
            item.queryResultArr = Object.values(row)
        }else{
            item.queryResultArr = row
        }
        this.subQueryData = item
        this.subQueryShow = true;
    }

    async load(data:any,query:any){
        this.params.queryParaIdArr = query.map((item:any)=>{
            return {
                key:item.id,
                value:item.defaultValue
            }
        })
        //生成表列
        this.columns = [];
        let vm = this;
        let columns = [];
        for (let i = 0; i < data.length; i++) {
            //使用闭包 防止变量污染
            let item = data[i];
            let row = item.queryResultDto.map((v,index) => {
                //表格需要key 
                if(item.chartType === 12){
                    return {
                        title:v.columnComment,
                        key:'k'+index
                    }
                }else{
                    return v.columnComment
                }
            });
            //数据钻取
            if(!!item.drillQueryTypeId){
                //表格数据钻取
                if(item.chartType === 12){
                    row.push({
                        title:'操作',
                        width:60,
                        render:(h:any,p:any)=>{
                            return h('el-button',{
                                props:{
                                    type:'text',
                                    size:'small',
                                },
                                on:{
                                    click:()=>{
                                        //行内数据，当前块数据
                                        this.getSub(p.row,item)
                                    }
                                }
                            },'详情')
                        }
                    })
                }
            }
            
            // this.columns.push({row})
            item.column = row
            item.loading = true
            columns.push(item);
        }
        //
        this.columns =columns;
        for (let i = 0; i < data.length; i++) {
            //使用闭包 防止变量污染
            (function (i)  {
                let item = data[i];
                vm.getData(item.id,i,item.chartType)
            })(i);
        }

    }
    async getData(queryTypeId:any,index:any,chartType:any){
        this.params.queryTypeId = queryTypeId;
        let res = await this.PageData(this.params)
        let data = res.data;
        //返回index和数据，防止异步下标错乱
        let robj:any = this.renderData(chartType,data.resultData,index,this.columns)
        this.list[robj.index] = robj.data
        this.columns[index].loading = false
    }
    mounted() {

    }
}
